// userService.js
import apiClient from "./apiClient";

export const getUserInvites = () => apiClient.get("/user-invites");
export const getUserInvitesById = (id) => apiClient.get(`/user-invites/${id}`);
export const getMyPendingUserInvites = () => apiClient.get("/user-invites/my/pending");
export const getUserInvitesByHash = (hash) => apiClient.get(`/user-invites/public/${hash}`);
export const registerUser = (data) => apiClient.post("/user-invites/register", data);
export const acceptUserInvite = (data) => apiClient.post("/user-invites/accept-invite", data);
export const createUserInvite = (data) => apiClient.post("/user-invites", data);
export const updateUserInvite = (id, data) => apiClient.put(`/user-invites/${id}`, data);
export const deleteUserInvite = (id) => apiClient.delete(`/user-invites/${id}`);
export const deleteUserInviteByHash = (hash) => apiClient.delete(`/user-invites/public/${hash}`);